import React from 'react';
import HeroSection from '../components/HeroSection';
import WhatWeDoSection from '../components/WhatWeDoSection';
import ProjectsPreview from '../components/ProjectsPreview';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <WhatWeDoSection />
      <ProjectsPreview />
      <CTASection />
    </>
  );
};

export default HomePage;
